import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { getIconForVariant } from './inline-alert.utils';
export type InlineAlertVariant = 'error' | 'warning' | 'info' | 'neutral';
export type InlineAlertProps = {
  variant: InlineAlertVariant;
  children: React.ReactNode;
  className?: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
};
const InlineAlert = t0 => {
  const $ = _c(34);
  let children;
  let className;
  let cta;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      cta,
      children,
      variant: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = cta;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    cta = $[3];
    props = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "info" : t1;
  let t2;
  if ($[6] !== variant) {
    t2 = getIconForVariant(variant);
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const IconComponent = t2;
  const t3 = variant === "error";
  const t4 = variant === "warning";
  const t5 = variant === "info";
  const t6 = variant === "neutral";
  let t7;
  if ($[8] !== className || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = cx("flex flex-row align-top w-full p-2 gap-2 rounded", {
      "bg-error": t3,
      "bg-warning": t4,
      "bg-info": t5,
      "bg-primary border border-tertiary border-solid": t6
    }, className);
    $[8] = className;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = variant === "neutral" ? "primary" : variant;
  let t9;
  if ($[14] !== IconComponent || $[15] !== t8) {
    t9 = <div className="flex items-center justify-center flex-none h-5"><IconComponent color={t8} /></div>;
    $[14] = IconComponent;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = variant === "error";
  const t11 = variant === "warning";
  const t12 = variant === "info";
  const t13 = variant === "neutral";
  let t14;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t13) {
    t14 = cx("text-body-2 align-middle min-w-0", {
      "text-error": t10,
      "text-warning": t11,
      "text-info": t12,
      "text-primary": t13
    });
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== cta || $[23] !== variant) {
    t15 = cta && <button onClick={cta.onClick} className={cx("ml-1 underline cursor-pointer hover:opacity-70 active:opacity-85", {
      "text-current": variant !== "neutral",
      "text-accent": variant === "neutral"
    })} type="button">{cta.label}</button>;
    $[22] = cta;
    $[23] = variant;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== children || $[26] !== t14 || $[27] !== t15) {
    t16 = <span className={t14}>{children}{t15}</span>;
    $[25] = children;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== props || $[30] !== t16 || $[31] !== t7 || $[32] !== t9) {
    t17 = <div role="alert" className={t7} {...props}>{t9}{t16}</div>;
    $[29] = props;
    $[30] = t16;
    $[31] = t7;
    $[32] = t9;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};
export default InlineAlert;